import jwt_decode from 'jwt-decode';

class Permission {
    constructor() {
        this.permissions = null;
    }

    loadPermissions(custom) {
        let token = null;
        custom ? token = sessionStorage.getItem('access_token_custom') : token = localStorage.getItem('access_token');
        if (token){
            this.permissions = jwt_decode(token)?.roles ? jwt_decode(token).roles : null;
        }else {
            this.permissions = null;
        }
    }

    validatePermissions(permission, custom = false) {
        this.loadPermissions(custom);
        return this.permissions?.includes(permission);
    }
}

const permissionInstance = new Permission();
permissionInstance.loadPermissions();

export default permissionInstance;